import { render } from "./SheetExampleSwiper.vue?vue&type=template&id=8be9b4f4&scoped=true"
import script from "./SheetExampleSwiper.vue?vue&type=script&lang=js"
export * from "./SheetExampleSwiper.vue?vue&type=script&lang=js"

import "./SheetExampleSwiper.vue?vue&type=style&index=0&id=8be9b4f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be9b4f4"]])

export default __exports__